class FormMarkdown {
    Id: number;
    MarkdownIdentifier: string;
    Markdown: string;

    constructor(id: number, markdownIdentifier: string, markdown: string) {
        this.Id = id;
        this.MarkdownIdentifier = markdownIdentifier;
        this.Markdown = markdown;
    }
}

export default FormMarkdown;